import * as React from "react";
import {
  formatStatusColour,
  formatDate,
  formatSecure3d,
} from "app/utils/filters";
import BackOfficeAndSnapminLink from "app/components/BOComponents/BackOfficeAndSnapminLink";
import SnapminLink from "app/components/BOComponents/SnapminLink";

type Props = {
  bankCardChanges: any[];
  onAuthedBankCardLoadsSet: (authedBankCardLoads: string) => void;
};

export default class BankCardsList extends React.Component<Props> {
  authedBankCardLoads() {
    const authedBankCardLoads = this.props.bankCardChanges.filter(
      (bankCardLoad) => bankCardLoad.status === "authed"
    );

    return `${authedBankCardLoads.length} / ${this.props.bankCardChanges.length}`;
  }

  constructor(props: Props) {
    super(props);
    props.onAuthedBankCardLoadsSet(this.authedBankCardLoads());
  }

  componentWillReceiveProps(newProps: Props) {
    if (newProps.bankCardChanges !== this.props.bankCardChanges) {
      newProps.onAuthedBankCardLoadsSet(this.authedBankCardLoads());
    }
  }

  emptyBankCardList() {
    return (
      <tr>
        <td style={{ textAlign: "center" }} colSpan={7}>
          No cards loaded
        </td>
      </tr>
    );
  }

  bankCardList() {
    return this.props.bankCardChanges.map((bankCardChange, i) => {
      const checkExternalRef = () => {
        if (bankCardChange.external_reference !== null) {
          return (
            <BackOfficeAndSnapminLink
              backofficeUrl={`/snapscan/ops/card_loads/${bankCardChange.external_reference}/summary`}
              snapminUrl={bankCardChange.snapmin_url}
            >
              {bankCardChange.bin}
            </BackOfficeAndSnapminLink>
          );
        } else {
          return (
            <SnapminLink snapminUrl={bankCardChange.snapmin_url}>
              {bankCardChange.bin}
            </SnapminLink>
          );
        }
      };

      return (
        <tr
          key={i}
          style={{
            backgroundColor: formatStatusColour(bankCardChange.status),
          }}
        >
          <td> {formatDate(bankCardChange.created_at)}</td>
          <td> {checkExternalRef()} </td>
          <td>
            {bankCardChange.payserv_bank_card &&
              bankCardChange.payserv_bank_card.cardholder_name}
          </td>
          <td> {bankCardChange.country_code}</td>
          <td> {formatSecure3d(bankCardChange.secure3d_requested)}</td>
          <td> {bankCardChange.message}</td>
          <td>
            <BackOfficeAndSnapminLink
              backofficeUrl={`/snapscan/ops/devices/${bankCardChange.device.external_reference}/summary`}
              snapminUrl={bankCardChange.device.snapmin_url}
            >
              {bankCardChange.device.phone_number}
            </BackOfficeAndSnapminLink>
          </td>
        </tr>
      );
    });
  }

  render() {
    return (
      <table
        style={{
          fontSize: "14px",
          paddingTop: "10px",
          width: "100%",
        }}
        className="BOTable"
        cellPadding={0}
        cellSpacing={0}
      >
        <thead>
          <tr>
            <td colSpan={8}>
              <h3
                style={{
                  borderBottom: "1px solid rgb(204, 204, 204)",
                  paddingBottom: "10px",
                  fontWeight: 400,
                }}
              >
                Bank Card Changes
              </h3>
            </td>
          </tr>
          <tr>
            <th>Date</th>
            <th>Bin</th>
            <th>Name on card</th>
            <th>Country code</th>
            <th>Secure 3D</th>
            <th>Message</th>
            <th>Device</th>
          </tr>
        </thead>
        <tbody>
          {this.props.bankCardChanges.length > 0
            ? this.bankCardList()
            : this.emptyBankCardList()}
        </tbody>
      </table>
    );
  }
}
